import api from './api';

const adminService = {
  /**
   * Récupérer les statistiques du dashboard admin
   */
  /**
   * @param {object} [options] - Options additionnelles (ex. `{ signal }` pour annulation).
   */
  getDashboardStats: async (options = {}) => {
    try {
      const response = await api.get('/admin/dashboard-stats', options);
      return response;
    } catch (error) {
      if (error?.name === 'AbortError') throw error;
      console.error('Erreur lors de la récupération des statistiques:', error);
      throw error;
    }
  },

  /**
   * Récupérer les activités récentes (dernières créations sociétés/adhérents).
   * @param {number} [limit=10]
   * @param {object} [options] - Options additionnelles (ex. `{ signal }`).
   */
  getRecentActivities: async (
    { limit = 10, offset = 0, entityTypes, action, withStats = false } = {},
    options = {}
  ) => {
    try {
      const response = await api.get('/admin/recent-activities', {
        params: {
          limit,
          offset,
          entity_types: entityTypes,
          action: action || undefined,
          stats: withStats ? 'true' : undefined
        },
        ...options
      });
      return response;
    } catch (error) {
      if (error?.name === 'AbortError') throw error;
      console.error('Erreur lors de la récupération des activités récentes:', error);
      throw error;
    }
  },

  /**
   * Récupérer tous les utilisateurs avec pagination et filtres
   */
  getAllUsers: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const endpoint = queryParams ? `/admin/users?${queryParams}` : '/admin/users';
      const response = await api.get(endpoint);
      return response;
    } catch (error) {
      console.error('Erreur lors de la récupération des utilisateurs:', error);
      throw error;
    }
  },

  /**
   * Récupérer un utilisateur par ID
   */
  getUserById: async (id) => {
    try {
      const response = await api.get(`/admin/users/${id}`);
      return response;
    } catch (error) {
      console.error('Erreur lors de la récupération de l\'utilisateur:', error);
      throw error;
    }
  },

  /**
   * Créer un nouvel utilisateur
   */
  createUser: async (userData) => {
    try {
      const response = await api.post('/admin/users', userData);
      return response;
    } catch (error) {
      console.error('Erreur lors de la création de l\'utilisateur:', error);
      throw error;
    }
  },

  /**
   * Mettre à jour un utilisateur
   */
  updateUser: async (id, userData) => {
    try {
      const response = await api.put(`/admin/users/${id}`, userData);
      return response;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de l\'utilisateur:', error);
      throw error;
    }
  },

  /**
   * Supprimer un utilisateur (soft delete)
   */
  deleteUser: async (id) => {
    try {
      const response = await api.delete(`/admin/users/${id}`);
      return response;
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'utilisateur:', error);
      throw error;
    }
  },

  /**
   * Activer/Désactiver un utilisateur
   */
  toggleUserStatus: async (id, isActive) => {
    try {
      const response = await api.put(`/admin/users/${id}/status`, { is_active: isActive });
      return response;
    } catch (error) {
      console.error('Erreur lors de la modification du statut:', error);
      throw error;
    }
  }
};

export default adminService;
